import { useRef, useEffect, memo } from 'react'
import { CustomTextAreaProps } from './customTextArea.types'
import { InputCounter, TextArea } from './customTextArea.styles'

const CustomTextArea = ({
  disabled = false,
  maxSize = 0,
  currentSize = 0,
  ...props
}: CustomTextAreaProps) => {
  const commentInputRef = useRef<HTMLTextAreaElement>(null)
  useEffect(() => {
    const resizeTextArea = () => {
      const currentTarget = commentInputRef.current

      if (currentTarget) {
        currentTarget.style.height = `${currentTarget.scrollHeight}px`
      }
    }

    resizeTextArea()
  }, [props.value])

  return (
    <div className="_position-relative">
      {maxSize > 0 && (
        <InputCounter
          className="_position-absolute _d-flex _flex-row _align-items-center _justify-content-start _mr-3 _text-1"
          data-test="textarea-value-counter"
        >
          <span>{currentSize}</span>
          <span>/</span>
          <span>{maxSize}</span>
        </InputCounter>
      )}
      <TextArea
        {...props}
        disabled={disabled}
        className="_w-full _p-3 _pt-3 _bg-transparent _text-gray-900"
      />
    </div>
  )
}

export default memo(CustomTextArea)
